import {
  LayoutDashboard,
  HeartPulse,
  Boxes,
  ArrowDownToLine,
  ArrowUpFromLine,
  Cpu,
  Bot,
  GitBranch,
  Landmark,
  Map,
  BookOpen,
  Package,
  Image,
  Network,
  Settings,
  KeyRound,
  Building2,
  Shield,
  Radio,
  Activity,
  Zap,
  Archive,
  Brain,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  name: string;
  path: string;
  icon: LucideIcon;
  opsOnly?: boolean;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAVIGATION_GROUPS: NavGroup[] = [
  {
    label: 'PLATFORM',
    items: [
      { name: 'Overview', path: '/', icon: LayoutDashboard },
      { name: 'System Health', path: '/system', icon: HeartPulse },
      { name: 'App Instances', path: '/apps', icon: Boxes },
      { name: 'Agent Actions', path: '/agent-actions', icon: Zap },
    ],
  },
  {
    label: 'DATA PIPELINE',
    items: [
      { name: 'API Ingest', path: '/api-ingest', icon: ArrowDownToLine },
      { name: 'API Expose', path: '/api-expose', icon: ArrowUpFromLine },
      { name: 'API Observe', path: '/api-observe', icon: Activity, opsOnly: true },
      { name: 'IoT Shack', path: '/iotshack', icon: Cpu },
      { name: 'Data Flow Manager', path: '/dataflow', icon: GitBranch },
    ],
  },
  {
    label: 'STANDARDS & CATALOG',
    items: [
      { name: 'Contextualizer', path: '/contextualizer', icon: BookOpen },
      { name: 'PIM', path: '/pim', icon: Package },
      { name: 'DAM', path: '/dam', icon: Image },
      { name: 'Relationship Manager', path: '/relationships', icon: Network },
    ],
  },
  {
    label: 'AGENTS',
    items: [
      { name: 'Agent Manager', path: '/agents', icon: Bot },
      { name: 'Learning', path: '/learning', icon: Brain, opsOnly: true },
    ],
  },
  {
    label: 'PLATFORM APPS',
    items: [
      { name: 'Asset App', path: '/asset', icon: Landmark },
      { name: 'Identity', path: '/entity', icon: Building2 },
      { name: 'Mapper App', path: '/mapper', icon: Map },
    ],
  },
  {
    label: 'OPERATIONS',
    items: [
      { name: 'Users & Access', path: '/iam', icon: Shield, opsOnly: true },
      { name: 'Settings', path: '/settings', icon: Settings },
      { name: 'Secrets', path: '/secrets', icon: KeyRound, opsOnly: true },
      { name: 'Pulsar', path: '/ops/pulsar', icon: Radio, opsOnly: true },
      { name: 'Delta Changelog', path: '/ops/delta-changelog', icon: GitBranch, opsOnly: true },
      { name: 'Ops Handoff', path: '/ops/handoff', icon: Archive, opsOnly: true },
    ],
  },
];
